<template>
  <span :class="textClasses">{{ text }}{{ shouldAddSpace ? '\u00a0' : '' }}</span>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import getEnv from '@/utils/getEnv';

export default defineComponent({
  name: 'SubtitleText',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { isBofAEnvironment } = getEnv();

    const textClasses = computed((): string => {
      if (isBofAEnvironment) return 'text-grey';

      return 'text-small-caps text-monospace font-weight-normal font-italic';
    });

    /**
     * Because the text is in italics, we add a nbsp to avoid the text from not aligning with other items on the page
     */
    const shouldAddSpace = !isBofAEnvironment;

    return {
      textClasses,
      shouldAddSpace,
    };
  },
});
</script>
